<template>
  <RouterView />
</template>

<script setup>

</script>

<style lang="less">
  *{
    margin: 0;
    padding: 0;
  }
  html, body{
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    color: #333333;
  }
  #app {
    height: 100vh;
  }
  .container{
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
  }
</style>
